import CustomError from './CustomError'

export default class InvalidCustomAttributeOperationException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
